import { Container, Row, Col, Badge, Button, Card } from 'react-bootstrap';
import { motion } from 'motion/react';
import digitalData from '../../data/digitalData.json';

const HeroSection = () => {
  const { hero } = digitalData

  const getImage = (imageName) => {
    return require(`../../assets/${imageName}`)
  }

  const getUserImage = (imageName) => {
    return require(`../../assets/user_images/${imageName}`)
  }

  const contentVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const statVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: index * 0.1 + 0.5 }
    })
  }

  return (
    <section className="hero-section-digital d-flex align-items-center justify-content-center min-vh-100 position-relative">
      <Container>
        <Row className="align-items-center py-5">
          <Col lg={6}>
            <motion.div variants={contentVariants} initial="hidden" animate="visible">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
              >
                <Badge bg="success-subtle" text="success" className="fw-semibold mb-3">
                  {hero.badge}
                </Badge>
              </motion.div>
              <motion.h2 className="display-5 fw-bold mb-3"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                {hero.title}
              </motion.h2>
              <motion.p className="lead text-secondary mb-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                {hero.subtitle}
              </motion.p>
              <motion.div className="d-flex flex-wrap gap-2 align-items-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button href="#contactus" variant="success">Get a Strategy Call</Button>
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button href="#features" variant="outline-success">See How We Work</Button>
                </motion.div>
              </motion.div>
              <motion.div className="d-flex align-items-center gap-3 mt-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
              >
                <div className="d-flex align-items-center">
                  {hero.users.map((user, idx) => (
                    <motion.img key={idx} src={getUserImage(user)} className={`rounded-circle ${idx > 0 ? 'me-n2' : ''} border border-2 border-white`}
                      alt="user" width="40" height="40"
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.7 + idx * 0.1 }}
                    />
                  ))}
                </div>
                <small className="text-secondary">{hero.trustText}</small>
              </motion.div>
            </motion.div>
          </Col>
          <Col lg={6} className="mt-5 mt-lg-0">
            <motion.div variants={imageVariants} initial="hidden" animate="visible">
              <motion.div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-sm"
                whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
              >
                <img src={getImage(hero.image)} className="w-100 h-100 object-fit-cover" alt="analytics dashboard" />
              </motion.div>
              <Row className="g-3 mt-3">
                {hero.stats.map((stat, idx) => (
                  <Col xs={6} sm={4} key={idx}>
                    <motion.div
                      variants={statVariants}
                      initial="hidden"
                      animate="visible"
                      custom={idx}
                      whileHover={{ y: -5, transition: { duration: 0.2 } }}
                    >
                      <Card className="shadow-sm border-0 rounded-3">
                        <Card.Body className="py-3">
                          <h6 className="mb-0">{stat.value}</h6>
                          <small className="text-secondary">{stat.label}</small>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HeroSection;
